<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{roleid == 11 ? "Market Checker" : "Market Checker"}}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 11 || roleid == 12">
        <b-tab-item label="ລາຍການຕະຫຼາດ" v-if="roleid == 11">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="30%">
                        ສະຖານທີ່
                      </th>
                      <th class="has-text-centered " width="20%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketList" :key="data.MARKETID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }} {{ data.DISTRICT }} {{ data.VILLAGE }}
                      </td>
                     
                      

                      <td class="has-text-centered">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              getMarketSellBillDetail(data.MARKETID, data.MARKETNAME)
                            "
                            >ລາຍລະອຽດ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ວັນທີ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="selectedMarketName">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ວັນທີ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນເຂົ້າ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນອອກ
                      </th>
                      <th class="has-text-centered " width="20%">
                        ລາຍລະອຽດ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketSellBillDetail" :key="data.SELLDATE">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SELLDATE) }}
                      </td>
                      <td  class="has-text-right ">
                        {{ data.PRODUCTCOUNT }} 
                      </td>

                      <td  class="has-text-right ">
                        {{ data.AMOUNTCHECKIN }} 
                      </td>

                      <td  class="has-text-right ">
                        {{ data.AMOUNTCHECKOUT }} 
                      </td>
                     
                      

                      <td class="has-text-centered">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              getMarketSellBillDetailDate(data.SELLDATE)
                            "
                            >ລາຍລະອຽດ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="selectedMarketName_selecteddate">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຟາມ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື່ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ແຈ້ງເຂົ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ກວດເຂົ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ແຈ້ງອອກ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ກວດອອກ
                      </th>
                      <th class="has-text-right " width="20%">
                        ຈຳນວນ<br>ກັບຄືນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketSellBillDetailDate" :key="data.SELLID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FARMNAME }}
                      </td>
                      <td  class="has-text-left ">
                        {{ data.PRODUCTNAME }} 
                      </td>

                      <td  class="has-text-right ">
                        {{ data.AMOUNTIN }} 
                      </td>
                      <td  class="has-text-right ">
                        {{ data.AMOUNTCHECKIN }} 
                      </td>

                      <td  class="has-text-right ">
                        {{ data.AMOUNTOUT }} 
                      </td>
                      <td  class="has-text-right ">
                        {{ data.AMOUNTCHECKOUT }} 
                      </td>

                      <td  class="has-text-right ">
                        {{ data.AMOUNTRETURN  }} 
                      </td>

                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      
      activeTab:0 ,

      marketList: [],

      activeSubTab:0,

      selectedMarketID: null,
      selectedMarketName: null,
      marketFarmerList:[],
      selectedSelldate: null,
      selectedMarketName_selecteddate: null,

      marketSellBillDetail: [],
      marketSellBillDetailDate: [],
      

    };
  },
  methods: {
    getMarketSellBill() {
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getMarketSellBill(this.userProvinceID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.marketList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },


    getMarketSellBillDetail(MARKETID, MARKETNAME) {
      if(this.user.ROLEID == 12){
        this.activeTab =  0;
      }else{
        this.activeTab =  1;
      }
     
      console.log(" this.user.ROLEID : " +  this.user.ROLEID)
      console.log(" this.activeTab :" +  this.activeTab)
      this.selectedMarketID = MARKETID;
      this.selectedMarketName = MARKETNAME;
      RestAPI.getMarketSellBillDetail(MARKETID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.marketSellBillDetail = res.data;
          // this.selectedProductionid = productionid;
          // this.farmerProduction(productionid)
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    

    getMarketSellBillDetailDate(SELLDATE) {
      if(this.user.ROLEID == 12){
        this.activeTab =  1;
      }else{
        this.activeTab =  2;
      }
      this.selectedSelldate = SELLDATE;
      this.selectedMarketName_selecteddate = this.selectedMarketName +" " + this.dateFormatter(this.selectedSelldate);
      RestAPI.getMarketSellBillDetailDate(this.selectedMarketID, SELLDATE)
        .then(res => {
          this.marketSellBillDetailDate = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
   
    this.selectedMarketID =  this.user.ROLEID == 11 ? null : this.user.MARKETID;
    this.selectedMarketName =  this.user.ROLEID == 11 ? null : this.user.MARKETNAME;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID ? this.user.BRANCHPROVNICEID : 'all';
    this.selecteddate = new Date();
    this.formdate = new Date();
    this.getMarketSellBill();
    if(this.user.ROLEID == 12 ){
      this.getMarketSellBillDetail(this.selectedMarketID, this.selectedMarketName)
      //  this.activeTab =1;
    }else{
      //  this.activeTab= 0;
    }
    
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
